import React from 'react'
import { Layout } from 'antd'
import './App.css'
import Main from './Main'
import TopBar from './component/layout/TopBar'
import AppBreadcrumb from './component/layout/AppBreadcrumb'

const App: React.FC = () => (
    <Layout className="App">
        <TopBar />
        <main className="app-main">
            <AppBreadcrumb />
            <Main />
        </main>
    </Layout>
)

export default App
